import http from "../utility/http";

const Create = async (prescriber) => {
  return await http.post("/v1/prescriber", prescriber);
};
const Update = async (prescriber) => {
  return await http.put(`/v1/prescriber/${prescriber.id}`, prescriber);
};
const Delete = async (id) => {
  return await http.delete(`/v1/prescriber/${id}`, {});
};
const GetAll = async () => {
  //add pagination + sorting + filteration
  return await http.get("/v1/prescriber/list");
};

const GetById = async (id) => {
  return await http.get(`/v1/prescriber/${id}`);
};

const api = {
  GetById,
  GetAll,
  Create,
  Update,
  Delete,
};

export default api;
